<template>
  <div>
    <b-row>
      <b-col
        xs="12"
        md="8"
      >
        <b-card>
          <b-card-title>Genel Bilgi</b-card-title>
          <b-row>
            <b-col>
              <b-form-group label="Adı">
                <b-form-input
                  v-model="formData.name"
                  placeholder="Adı"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Soyadı">
                <b-form-input
                  v-model="formData.surname"
                  placeholder="Soyadı"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="E-Posta (İş)">
                <b-form-input
                  v-model="formData.email_business"
                  placeholder="E-Posta (İş)"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="E-Posta (Kişisel)">
                <b-form-input
                  v-model="formData.email_personal"
                  placeholder="E-Posta (Kişisel)"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="Telefon (İş)">
                <b-input-group>
                  <b-input-group-prepend is-text>
                    TR (+90)
                  </b-input-group-prepend>
                  <cleave
                    id="phone_business"
                    v-model="formData.phone_business"
                    class="form-control"
                    :raw="false"
                    :options="options.phone"
                    placeholder="Telefon (İş)"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Telefon (Kişisel)">
                <b-input-group>
                  <b-input-group-prepend is-text>
                    TR (+90)
                  </b-input-group-prepend>
                  <cleave
                    id="phone_personal"
                    v-model="formData.phone_personal"
                    class="form-control"
                    :raw="false"
                    :options="options.phone"
                    placeholder="Telefon (Kişisel)"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group label="İşe Başlama Tarihi">
                <b-form-datepicker
                  id="example-i18n-picker"
                  v-model="formData.started"
                  v-bind="{labelNoDateSelected: 'Tarih Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
                  locale="tr"
                  start-weekday="1"
                  class="mb-1"
                  :max="today"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Sözleşme Türü">
                <v-select
                  v-model="contract"
                  :options="contracts"
                  label="title"
                  :reduce="contract => contract.id"
                  placeholder="Sözleşme Türü"
                />
              </b-form-group>
            </b-col>
            <b-col v-if="formData.contracted">
              <b-form-group label="Sözleşme Bitiş Tarihi">
                <b-form-datepicker
                  id="contracted"
                  v-model="formData.contracted"
                  v-bind="{labelNoDateSelected: 'Tarih Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
                  locale="tr"
                  start-weekday="1"
                  class="mb-1"
                  :min="today"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-button
                variant="primary"
                class="mt-2"
                @click="submitForm"
              >
                Kaydet
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col
        xs="12"
        md="4"
      >
        <b-card class="text-center">
          <b-card-title>Personel Kartı</b-card-title>
          <b-avatar
            v-if="formData.name && formData.surname"
            size="150px"
            variant="secondary"
            :text="formData.name.charAt(0)+formData.surname.charAt(0)"
          />
          <div
            v-if="formData.name"
            class="mt-2"
          >
            <div class="font-medium-4 font-weight-bolder">
              {{ formData.name }} {{ formData.surname }}
            </div>
            <hr>
          </div>
          <div
            v-if="formData.started"
            class="mt-2"
          >
            <div class="font-weight-bold">
              İşe Başlama Tarihi
            </div>
            <div>{{ this.moment(formData.started).format('DD.MM.YYYY') }}</div>
          </div>
          <div
            v-if="formData.email_business"
            class="mt-2"
          >
            <div class="font-weight-bold">
              E-Posta (İş)
            </div>
            <div>{{ formData.email_business }}</div>
          </div>
          <div
            v-if="formData.phone_business"
            class="mt-2"
          >
            <div class="font-weight-bold">
              Telefon (İş)
            </div>
            <div>{{ formData.phone_business }}</div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import {
  BRow, BCol, BCard, BCardTitle, BFormGroup, BFormInput, BAvatar, BFormDatepicker, BInputGroup, BInputGroupPrepend, BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.tr'

export default {
  name: 'General',
  components: {
    BFormDatepicker,
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BFormInput,
    BAvatar,
    BInputGroup,
    BInputGroupPrepend,
    BButton,
    BFormGroup,
    Cleave,
    vSelect,
  },
  data() {
    return {
      submitStatus: false,
      contract: null,
      contracts: [
        {
          id: 0,
          title: 'Süresiz',
        },
        {
          id: 1,
          title: 'Süreli',
        },
      ],
      today: this.moment().format('YYYY-MM-DD'),
      options: {
        phone: {
          phone: true,
          phoneRegionCode: 'TR',
        },
        date: {
          date: true,
          delimiter: '.',
          datePattern: ['d', 'm', 'Y'],
        },
        block: {
          blocks: [11],
          uppercase: true,
        },
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'hundreds',
        },
      },
      formData: {
        id: null,
        name: null,
        surname: null,
        email_business: null,
        email_personal: null,
        phone_business: null,
        phone_personal: null,
        started: null,
      },
    }
  },
  computed: {
    employee() {
      return this.$store.getters['employees/getEmployee']
    },
    saveStatus() {
      return this.$store.getters['employees/getEmployeeSaveStatus']
    },
  },
  watch: {
    employee(val) {
      this.setFormData(val)
    },
    saveStatus(val) {
      if (val.status === true) {
        const config = {
          icon: 'success',
          title: 'İşlem Başarılı!',
          text: 'Kayıt işleminiz başarılı!',
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
      } else if (val.status === false) {
        const config = {
          icon: 'error',
          title: 'İşlem Hatası!',
          text: 'Kayıt işleminiz yapılamadı.! Lütfen tekrar deneyiniz.',
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
      }
      this.submitStatus = false
    },
  },
  created() {
    this.getEmployee()
  },
  methods: {
    getEmployee() {
      this.$store.dispatch('employees/employeeView', this.$route.params.id)
    },
    setFormData(data) {
      this.formData = data
    },
    sweetAlert(config) {
      this.$swal({
        icon: config.icon,
        title: config.title,
        text: config.text,
        html: config.html,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        confirmButtonText: config.buttonText,
        buttonsStyling: false,
      })
    },
    submitForm() {
      this.submitStatus = true
      this.$store.dispatch('employees/employeeSave', this.formData)
    },
  },
}

</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
